// @flow
import React from 'react';

import { PriceTicket } from 'Components/widgets/price-ticket/PriceTicket';
import { addTranslationKeys } from 'Src/i18n';
import type {
  CMSProps,
  GQLProps,
} from 'Client/cms/toolkit/product-price-ticket/productPriceTicket.resolver';

const DATE_FORMAT = 'D MMMM YYYY';

type Props = {
  ...$Exact<CMSProps>,
  ...$Exact<GQLProps>,
};

export function ProductPriceTicketLine({
  adult,
  adults,
  askForQuotation,
  book,
  collapseLabels,
  config,
  cruise,
  departureCityLabel,
  departureDateFormat = DATE_FORMAT,
  departureDateLabel,
  durationPlaceholder,
  fromToPlaceholder,
  product,
  seeAllPrices,
}: Props) {
  if (!product) {
    return null;
  }

  const { travelAdvisor, ...i18nConfig } = config;

  addTranslationKeys({
    ...i18nConfig,
    productPriceTicketLine: {
      adult,
      adults,
      askForQuotation,
      book,
      collapseLabels,
      departureCityLabel,
      departureDateFormat,
      departureDateLabel,
      durationPlaceholder,
      fromToPlaceholder,
      seeAllPrices,
    },
  });

  return (
    <div className="Line Line-PriceTicket" data-testid="Line-ProductPriceTicket">
      <PriceTicket cruise={cruise} product={product} travelAdvisorConfig={travelAdvisor} />
    </div>
  );
}
